module.exports = __webpack_public_path__ + "img/icon-phone.cab7f49e.svg";